<template>

  <div class="menu-title">
    <p>Drinks & Desserts</p>
  </div>



  <div class="menu-sub-title">
    <p>Refrigerated Drinks</p>
  </div>

  <div class="Drinks-container-1">

    <div class="Drinks-grid-1">
      <div>
        <img class="menu-pic" src="../assets/DrinksCalpicoTea.jpg">
      </div>
      <div class="menu-text">
        <p>Calpico & Tea</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-2">
      <div>
        <img class="menu-pic" src="../assets/DrinksCoffeeJuice.jpg">
      </div>
      <div class="menu-text">
        <p>Coffee & Juice</p>
        <!-- <p>3.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-3">
      <div>
        <img class="menu-pic" src="../assets/DrinksGatorade.jpg">
      </div>
      <div class="menu-text">
        <p>Gatorade</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>

  </div>


  <div class="Drinks-container-2">

    <div class="Drinks-grid-4">
      <div>
        <img class="menu-pic" src="../assets/DrinksRamuneTea.jpg">
      </div>
      <div class="menu-text">
        <p>Ramune & Tea</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-5">
      <div>
        <img class="menu-pic" src="../assets/DrinksSoda.jpg">
      </div>
      <div class="menu-text">
        <p>Soda</p>
        <!-- <p>.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-6">
      <div>
        <img class="menu-pic" src="../assets/DrinksWater.jpg">
      </div>
      <div class="menu-text">
        <p>Water</p>
        <!-- <p>.99</p> -->
      </div>
    </div>

  </div>




  <div class="menu-sub-title">
    <p>Frozen Desserts</p>
  </div>


  <div class="Drinks-container-3">


    <div class="Drinks-grid-7">
      <div>
        <img class="menu-pic" src="../assets/DessertBars.jpg">
      </div>
      <div class="menu-text">
        <p>Frozen Bars</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-8">
      <div>
        <img class="menu-pic" src="../assets/DessertCoolish.jpg">
      </div>
      <div class="menu-text">
        <p>Frozen Coolish</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>

    <div class="Drinks-grid-9">
      <div>
        <img class="menu-pic" src="../assets/DessertWafer.jpg">
      </div>
      <div class="menu-text">
        <p>Frozen Wafer</p>
        <!-- <p>2.99</p> -->
      </div>
    </div>
    
  </div>

</template>


<script>

  export default {
    name: 'DrinksBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }

  .menu-sub-title {
    display: inline-flex;
    float: left;
    border: 2px solid darkblue;
    background-color: rgb(255,204,211);
    color: darkblue;
    height: 2.2rem;
    line-height: 1rem;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    font-weight: bold;
    margin-top: 1vw;
    margin-left: 6vw;
  }


  .Drinks-container-1, .Drinks-container-2, .Drinks-container-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    margin-bottom: 2rem;
    color: darkblue;
  }

  .menu-sub-title {
    text-align: center;
    text-decoration: underline;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 3rem;
    margin-left: 6vw;
    color: darkblue;
  }

  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>